// extracted by mini-css-extract-plugin
module.exports = {"container":"prac_container__20coB","sHeading":"prac_sHeading__JegOf","heading":"prac_heading__MxxxP"};